import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import DetailStoreMobile from './DetailStoreMobile';
import StoreOverview from './component/StoreOverview';

const StoreDetailPage = () => {
  const isMobile = useMediaQuery({maxWidth: 768});

  if (isMobile) {
    return <DetailStoreMobile />;
  }
  
  return (
    <Container>
      {/* <LeftSection>
        <StoreInfoPanel />
      </LeftSection>
      <RightSection>
        <StoreScreenTable />
      </RightSection> */}
      <StoreOverview />
    </Container>
  );
};

export default StoreDetailPage;

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  padding: 16px;
`;

// const LeftSection = styled.div`
//   width: 300px;
//   overflow-y: auto;
//   background-color: ${Colors.neutral.bg[1]};
//   border-right: 1px solid ${Colors.neutral.border[1]};
// `;

// const RightSection = styled.div`
//   flex: 1;s
//   overflow-y: auto;
//   padding: 8px;
// `;
